import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import promise from 'es6-promise';
import './ui.js'
import './login'
import './assets/scss/index.scss'
import Bus from './utils/eventBus'
process.env.MOCK && require('@/mock')
promise.polyfill();

//引入多语言支持
import i18n from './tools/i18n'

Vue.config.productionTip = false

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  data: {
    Bus
  },
  i18n,     //挂载i18n
  router,
  store,
  components: { App },
  template: '<App ref="root"/>'
})



// WEBPACK FOOTER //
// ./src/main.js